export const DecrementIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="min-icon" transform="translate(-2 -2)">
            <path id="Path_8" data-name="Path 8"
                  d="M14,2A12,12,0,1,1,2,14,12,12,0,0,1,14,2Zm0,2.4A9.6,9.6,0,1,0,23.6,14,9.6,9.6,0,0,0,14,4.4Zm6,8.4a1.2,1.2,0,0,1,0,2.4H8a1.2,1.2,0,1,1,0-2.4Z"
                  fill="#545454" fillRule="evenodd"/>
        </g>
    </svg>
)